import { makeStyles, colors } from '@material-ui/core'

const styles = makeStyles((theme) => ({
  chipActived: {
    backgroundColor: colors.green[100],
    color: colors.green[800],
    fontWeight: 700,
    height: 21,
  },
  chipCanceled: {
    backgroundColor: colors.grey[100],
    color: colors.grey[800],
    fontWeight: 700,
    height: 21,
  },
  chipRequested: {
    backgroundColor: colors.orange[100],
    color: colors.orange[800],
    fontWeight: 700,
    height: 21,
  },
  chipPending: {
    backgroundColor: colors.blue[100],
    color: colors.blue[800],
    fontWeight: 700,
    height: 21,
  },
}))

export default styles
